export default __webpack_public_path__ + "static/media/careers.48c58be6.png";